export type ParkingType = "FLAT" | "SOLID" | "MECHANICAL";

export type ParkingTypeText = "平置き" | "立体" | "機械式";

/**
 * 駐車場タイプを翻訳
 * @param type ParkingType
 * @return
 */
export const convertParkingType = (type: ParkingType): ParkingTypeText => {
  switch (type) {
    case "FLAT":
      return "平置き";
    case "SOLID":
      return "立体";
    case "MECHANICAL":
      return "機械式";
  }
};
